/**
 * Wire-level value types shared by server and client (docs/43 §2).
 *
 * Enums are `as const` objects plus a same-named union type rather than
 * `const enum`: the repo compiles with `isolatedModules` and
 * `verbatimModuleSyntax`, where cross-file const enums are a runtime footgun,
 * and the room needs real runtime values for its id → handler tables.
 */
export const Gait = { Walk: 0, Run: 1, Carry: 2 };
/** 4 facings (vision §6); SE/NE are authored, SW/NW mirrored. */
export const Facing = { SE: 0, SW: 1, NE: 2, NW: 3 };
/** Body type (98 Q-38). */
export const Body = { Male: 0, Female: 1 };
/**
 * Bits of `Player.flags` (92 §3.2): 43's PresenceFlag bits plus the sprint's
 * Smelling (98 Q-40, visible to everyone) and Talking (voice) bits.
 */
export const PresenceFlag = {
    Away: 1,
    NetWahala: 2,
    OnPhone: 4,
    InVoice: 8,
    Building: 16,
    Typing: 32,
    Smelling: 64,
    Talking: 128,
};
/** Flags a client may set or clear itself with `C2S.Presence` (43 §3.3). */
export const CLIENT_SETTABLE_FLAGS = PresenceFlag.Away | PresenceFlag.Typing | PresenceFlag.OnPhone;
/** StateView tag for owner-only fields (43 P11). Unused in Sprint 1 (92 A8 uses `S2C.OwnerState`). */
export const VIEW_OWNER = 1;
/** Encodes an eid as the base-36 key used in Schema maps (43 P9). */
export const eidKey = (e) => e.toString(36);
/** Decodes a base-36 Schema map key back to an eid. */
export const eidFromKey = (k) => parseInt(k, 36);
